import { Directive } from '@angular/core';

@Directive({
  selector: '[xpo-large-button], [xpoLargeButton]',
  host: {
    class: 'xpo-LargeButton',
  },
})
export class XpoLargeButton {}
